export const CATEGORIES = ['Bills', 'Food', 'Groceries', 'Entertainment', 'Other'];